import React from 'react';
import classNames from 'classnames';
import styles from './index.module.scss';

// Кнопка з макета: золотий градієнт, біла обводка, тінь.
const BrandButton = ({
  children,
  onClick,
  disabled = false,
  isLoading = false,
  className,
  type = 'button'
}) => (
  <button
    type={type}
    className={classNames(styles.button, className)}
    onClick={onClick}
    disabled={disabled || isLoading}
  >
    {isLoading && <span className={styles.spinner} />}
    <span className={styles.label}>{children}</span>
  </button>
);

export default BrandButton;
